import React, { useState, useEffect, useRef } from "react";
import { searchExchangePair } from "../../../../actions/bot-action";
import { connect } from "react-redux";
import "./SymbolSearchBox.scss";

const SymbolSearchBox = (props) => {
  const {
    searchExchangePair,
    selectedExchange,
    selected,
    selectedPair,
  } = props;
  const [searchTerm, setSearchTerm] = useState(selectedPair ? selectedPair.label : "");
  const [results, setResults] = useState([]);
  const [emptyResult, setEmptyResult] = useState(false);
  const searchBoxRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
        searchBoxRef.current &&
        !searchBoxRef.current.contains(event.target) &&
        event.target.tagName !== "LI" // Check if clicked element is an <li> element
      ) {
        resetSearch();
      }
  };
  const resetSearch = ()=>{
    setResults([]);
    setEmptyResult(false);
    //setSearchTerm(selectedPair ? selectedPair.label : "")
  }

  const handleInputChange = (event) => {
    let symbol = event.target.value;
    if (symbol.includes("/")) {
      symbol = symbol.split("/")[0];
    }
    setSearchTerm(symbol);
    if (symbol) {
      searchExchangePair(selectedExchange.id, symbol).then((res) => {
        if (res && res.length > 0) {
          setResults(res);
        } else {
          setResults([]);
          setEmptyResult(true);
        }
      });
    } else {
      setEmptyResult(true);
      setResults([]);
    }
  };

  const handleResultClick = (symbol) => {
    setResults([]);
    setEmptyResult(false);
    if (symbol) {
      selected(symbol);
      setSearchTerm(symbol.pair.from + "/" + symbol.pair.to);
    }
  };

  return (
    <>
      <div className="search-box" >
        <input
          type="text"
          value={searchTerm}
          onChange={handleInputChange}
          placeholder="Enter symbol to trade"
          className="form-control"
          ref={searchBoxRef}
        />
        <div >
            {results.length > 0 && (
                <ul className="search-results">
                    {results.map((result, index) => (
                    <li
                        key={index}
                        onClick={(event) => {
                        event.stopPropagation(); // Prevent event propagation
                        handleResultClick(result);
                        }}
                    >
                        {result.pair.from +'/'+result.pair.to}
                    </li>
                    ))}
                </ul>
            )}
            {results.length === 0 && emptyResult && (
            <ul className="search-results">
                <li onClick={()=>resetSearch()}>No stocks found</li>
            </ul>
            )}
        </div>
        
      </div>
    </>
  );
};

export default connect(null, { searchExchangePair })(SymbolSearchBox);
